module.exports = __webpack_public_path__ + "img/chart.d5db6c26.svg";